'use strict';

var Emitter = require('cjs-emitter'),
    config = require('../config'),
    random = require('./utils/random'),
    degrToStr = require('./utils/degree.2.string'),
    weatherIcons = require('./weather.icons'),
    fullMonthNames = [
        gettext('January'),
        gettext('February'),
        gettext('March'),
        gettext('April'),
        gettext('May'),
        gettext('June'),
        gettext('July'),
        gettext('August'),
        gettext('September'),
        gettext('October'),
        gettext('November'),
        gettext('December')
    ],
    fullDaysOfWeek = [
        gettext('Sunday'),
        gettext('Monday'),
        gettext('Tuesday'),
        gettext('Wednesday'),
        gettext('Thursday'),
        gettext('Friday'),
        gettext('Saturday')
    ],

    // randomize time weather update
    REQUEST_TIMEOUT_TIME = 60 * random(10, 50),
    UPDATE_TIMEOUT_TIME = 1000 * 60 * random(120, 360),

    hash = {
        data: null,
        url: config.weatherServerURL + 'getCheck.php?id=' + core.environment.Image_Desc,
        updateTimeout: -1,
        update: function ( callback ) {
            var self = this,
                client = new XMLHttpRequest();

            client.open('GET', this.url);

            debug.log('GET HASH: ' + this.url, 'red');

            client.onload = function () {
                var data = null;

                try {
                    data = JSON.parse(this.responseText);
                } catch ( error ) {
                    debug.info(error);
                }

                if ( this.status === 200 && data && data.code === 0 ) {
                    self.data = data.data;
                    if ( callback ) {
                        callback();
                    }
                } else {
                    self.updateTimeout = setTimeout(function () {
                        self.update(callback);
                    }, REQUEST_TIMEOUT_TIME);
                }
            };
            client.timeout = 10;
            client.ontimeout = client.onerror = function () {
                self.updateTimeout = setTimeout(function () {
                    self.update(callback);
                }, REQUEST_TIMEOUT_TIME);
            };
            client.send(null);
        }
    };


function Weather ( constructorConfig, callback ) {
    this.forecast = {};
    this.location = constructorConfig.location || null;
    this.updateTimeout = -1;
    this.badRequests = 0;

    // parent constructor call
    Emitter.call(this);

    // parent constructor call
    if ( constructorConfig.events ) {
        this.addListeners(constructorConfig.events);
    }

    if ( this.location ) {
        this.getForecast(this.location, callback);
    }
}

// inheritance
Weather.prototype = Object.create(Emitter.prototype);
Weather.prototype.constructor = Weather;

// weather service response codes
Weather.prototype.RESPONSE_CODE_OK = 0;
Weather.prototype.RESPONSE_CODE_CODE_NO_DATA = 1;
Weather.prototype.RESPONSE_CODE_STALE_DATA = 2;
Weather.prototype.RESPONSE_CODE_BAD_PARAMS = 3;
Weather.prototype.RESPONSE_CODE_BAD_HASH = 5;


Weather.prototype.normalizeForecast = function ( data ) {
    var forecast = {
            current: {
                dayName: '',
                date: '',
                indicator: '',
                description: '',
                temperatureDay: '',
                temperatureNight: '',
                temperature: '',
                humidity: '',
                windSpeed: ''
            },
            days: [
                {
                    dayName: '',
                    date: '',
                    indicator: '',
                    description: '',
                    temperatureDay: '',
                    temperatureNight: ''
                },
                {
                    dayName: '',
                    date: '',
                    indicator: '',
                    description: '',
                    temperatureDay: '',
                    temperatureNight: ''
                },
                {
                    dayName: '',
                    date: '',
                    indicator: '',
                    description: '',
                    temperatureDay: '',
                    temperatureNight: ''
                }
            ]
        },
        index, day, date;

    day = data.days[0];

    forecast.current.indicator = 'img/' + screen.height + '/' + weatherIcons[day.id].icon + '.active.png';
    forecast.current.description = weatherIcons[day.id].desc;
    forecast.current.windDirection = degrToStr(data.current.wd);
    forecast.current.temperature = data.current.tcc;
    forecast.current.temperatureDay = day.thc;
    forecast.current.temperatureNight = day.tlc;
    forecast.current.windSpeed = data.current.wsk.toFixed(1);
    forecast.current.humidity = data.current.h + '%';
    date = day.d.split('-');
    day = new Date(date[0], date[1] - 1, date[2]);
    forecast.current.dayName = fullDaysOfWeek[day.getDay()];
    forecast.current.date = date[2] + ' ' + fullMonthNames[date[1] - 1];

    for ( index = 1; index < 4; ++index ) {
        day = data.days[index];
        forecast.days[index - 1].dayName = '';
        forecast.days[index - 1].date = '';
        forecast.days[index - 1].indicator = 'img/' + screen.height + '/' + weatherIcons[day.id].icon + '.normal.png';
        forecast.days[index - 1].description = weatherIcons[day.id].desc;
        forecast.days[index - 1].temperatureDay = day.thc;
        forecast.days[index - 1].temperatureNight = day.tlc;

        date = day.d.split('-');
        day = new Date(date[0], date[1] - 1, date[2]);
        forecast.days[index - 1].dayName = fullDaysOfWeek[day.getDay()];
        forecast.days[index - 1].date = date[2] + ' ' + fullMonthNames[date[1] - 1];
    }

    return forecast;
};


/**
 * Get forecast information with given location and callback for load event.
 *
 * @param {Object} location - location object
 * @param {Function} callback - callback with actions after forecast is loaded
 */
Weather.prototype.getForecast = function ( location, callback ) {
    var self = this,
        ask = 'lat=' + location.lat + '&lon=' + location.lon,
        hashed = core.tools.hash((Math.round(location.lat * 100) / 100) + ',' + (Math.round(location.lon * 100) / 100), hash.data),
        url = config.weatherServerURL + 'getData.php?' + ask /*+ '&langid=' + config.langv[core.environment.language]*/ + '&hk=' + hashed,
        client = new XMLHttpRequest();

    client.open('GET', url);

    debug.log('REQUEST FORECAST: ' + url, 'cyan');

    clearTimeout(this.updateTimeout);

    client.onload = function () {
        var response;

        try {
            response = JSON.parse(this.responseText);
        } catch ( error ) {
            debug.info(error);
            ++self.badRequests;
            self.updateTimeout = setTimeout(function () {
                hash.update(function () {
                    self.getForecast(location, callback);
                });
            }, REQUEST_TIMEOUT_TIME);
            response = {code: -1};
        }

        switch ( response.code ) {
            case self.RESPONSE_CODE_OK:
                self.forecast = response.data;

                if ( self.forecast.current ) {
                    self.emit('change', self.forecast);

                    // Invoke callback on success.
                    callback(self.normalizeForecast(self.forecast));
                }

                self.updateTimeout = setTimeout(function () {
                    self.getForecast(location, callback);
                }, UPDATE_TIMEOUT_TIME);
                break;

            case self.RESPONSE_CODE_CODE_NO_DATA:
            case self.RESPONSE_CODE_STALE_DATA:
            case self.RESPONSE_CODE_BAD_HASH:
            case self.RESPONSE_CODE_BAD_PARAMS:
            default:
                self.emit('error', response.code);
                self.updateTimeout = setTimeout(function () {
                    hash.update(function () {
                        self.getForecast(location, callback);
                    });
                }, REQUEST_TIMEOUT_TIME);
                break;
        }
    };

    client.send(null);
};


module.exports = Weather;
